import type { EnhancedStore } from '@reduxjs/toolkit';

let appStore: EnhancedStore | null = null;

export function setAppStore(store: EnhancedStore): void {
  appStore = store;
}

export function getAppStore(): EnhancedStore {
  if (!appStore) {
    throw new Error('Redux store has not been registered yet.');
  }
  return appStore;
}
